import consumer from './consumer';

document.addEventListener('DOMContentLoaded', () => {
  // This function is executed after 3mn if Doclift does not answer
  function docliftDoesNotAnswer() {
    if (!(typeof iframe == 'object')) {
      consumer.disconnect();
      $('#subscriptionStep2').addClass('d-none');
      $('#subscriptionStep3').addClass('d-none');
      $('#subscriptionStep4').addClass('d-none');
      $('#subscriptionStepError').removeClass('d-none');
    }
  }

  function generateContractIframe(documentUrl) {
    iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.height = '86%';
    iframe.src = documentUrl;

    $('#subscriptionStep3').prepend(iframe);

    $('.edit_subscription').on('ajax:success', function (event) {
      $('#subscriptionStep3').addClass('d-none');
      $('#subscriptionStep4').removeClass('d-none');
      $('.breadcrumb-element:nth-child(3)').removeClass('current');
      $('.breadcrumb-element:nth-child(3)').addClass('past');
      $('.breadcrumb-element:nth-child(4)').removeClass('next');
      $('.breadcrumb-element:nth-child(4)').addClass('current');
      $('#current_step').text('4');
    });
  }

  let docliftDoesNotAnswerTimer = setTimeout(docliftDoesNotAnswer, 180000);

  if (!$('#signature-subscription-id').length) {
    return;
  }

  consumer.subscriptions.create(
    { channel: 'SignatureChannel', subscription_id: $('#signature-subscription-id').data('id') },
    {
      received(data) {
        try {
          if (data.status == 'success') {
            if (data.document_url) {
              clearTimeout(docliftDoesNotAnswerTimer);
              generateContractIframe(data.document_url);

              // Enable the button to load the contract and display the success message
              $('#contractLoadedButton').prop('disabled', false);
              $('#subscriptionStep2 #step-title').text($('#subscriptionStep2').data('title-in-case-of-doc-ready'));
              $('#subscriptionStep2 #step-image').attr('src', $('#subscriptionStep2').data('image-in-case-of-doc-ready'));
              $('#generatingDocInProgressExplanations').addClass('d-none');
              $('#generatingDocReadyExplanations').removeClass('d-none');

              $('#contractLoadedButton').on('click', (_e) => {
                $('#subscriptionStep3').removeClass('d-none');
                $('#subscriptionStep2').addClass('d-none');

                $('.breadcrumb-element:nth-child(2)').removeClass('current');
                $('.breadcrumb-element:nth-child(2)').addClass('past');
                $('.breadcrumb-element:nth-child(3)').removeClass('next');
                $('.breadcrumb-element:nth-child(3)').addClass('current');
                $('#current_step').text('3');
              });
            } else if (data.redirection_url) {
              // When the contract is signed, we redirect to the subscription show.
              window.location.href = data.redirection_url;
            }
          } else {
            setTimeout(() => {
              $('#subscriptionStep2').addClass('d-none');
              $('#subscriptionStep3').addClass('d-none');
              $('#subscriptionStep4').addClass('d-none');
              $('#subscriptionStepError').removeClass('d-none');
            }, 5000);
          }
        } catch {
          setTimeout(() => {
            $('#subscriptionStep2').addClass('d-none');
            $('#subscriptionStep3').addClass('d-none');
            $('#subscriptionStep4').addClass('d-none');
            $('#subscriptionStepError').removeClass('d-none');
          }, 5000);
        }
      },
      rejected() {
        setTimeout(() => {
          $('#subscriptionStep2').addClass('d-none');
          $('#subscriptionStep3').addClass('d-none');
          $('#subscriptionStep4').addClass('d-none');
          $('#subscriptionStepError').removeClass('d-none');
        }, 5000);
        this.uninstall();
      },
    },
  );
});
